export function schema_projet(project) {
	return {
		title: "Paramètres",
		type: "object",
		required: ["project", "tags"],
		properties: {
			project: {
				title: "projet",
				type: "string",
				default: project.uid,
				options: { hidden: true },
			},
			tags: {
				type: "string",
				title: "Tag du projet",
			},
			params: {
				type: "object",
				title: "Paramètres de traitement",
				options: {
					hidden: true,
				}
			},
			csv: {
				type: "boolean",
				format: "checkbox",
				title: "Mode csv",
			},
			column_file: {
				title: "Colonnes des noms des fichiers",
				type: "string",
			},
			column_url: {
				title: "Colonnes des urls des fichiers",
				type: "string",
			},
			column_project: {
				title: "Colonnes des noms des projets",
				type: "string",
			},
			column_tags: {
				title: "Colonnes des tags",
				type: "string",
			},
			doc_project_possibilities: {
				type: "array",
				title: "Documentation - projets (uuid) pouvant être appelés",
				format: "table",
				items: {
					title: "Projet",
					type: "string"
				}
			},
			nb_by_lot: {
				title: "Nombre de fichiers par traitement",
				type: "number"
			},
			size_max: {
				title: "Poids des fichiers par traitement",
				type: "number"
			},
			sequential: {
				title: "Exécuter les traitements un par un",
				type: "boolean",
				format: "checkbox",

			}
		},
	};
}
